// extracted by mini-css-extract-plugin
export default {"tabContent":"GeneralStyles_tabContent__RzkRN"};